export default __webpack_public_path__ + "locales/ja-JP/VersionHistory.json?hash=1805987b99bf60bb98b1adc21923483d";